import React from 'react';
import {
  withVisibleDesktop,
  withVisibleXxl,
  withVisibleXl,
  withVisibleXs,
  withHiddenDesktop
} from '@/hocs/withResponsiveUtils';

const Break = props => <br {...props} />;
const BreakVisibleInDesktop = withVisibleDesktop(Break);
const BreakVisibleXxl = withVisibleXxl(Break);
const BreakVisibleXl = withVisibleXl(Break);
const BreakVisibleXs = withVisibleXs(Break);
const BreakHiddenDesktop = withHiddenDesktop(Break);

export {
  Break,
  BreakVisibleInDesktop,
  BreakVisibleXxl,
  BreakVisibleXl,
  BreakVisibleXs,
  BreakHiddenDesktop
};
